import {KTIcon} from '../../../../../_metronic/helpers'

const DomainListToolbar = () => {
  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
        <button
          type='button'
          className='btn btn-sm fs-6'
            style={{height:'40px',background:'#0e9f6e',color:'#fff'}}
            onMouseEnter={(e: React.MouseEvent<HTMLElement>) =>
              (e.currentTarget.style.backgroundColor = '#148363')
            }
            onMouseLeave={(e: React.MouseEvent<HTMLElement>) =>
              (e.currentTarget.style.backgroundColor = '#0e9f6e')
            }
        >
          <KTIcon iconName='plus' className='fs-2 text-white' />
          Add Domain
        </button>
    </div>
  )
}

export {DomainListToolbar}
